/**
 * @param {string} item - The issue object key.
 * @param {string} summary - The issue summary field.
 * @returns {string} The release note field or a default message.
 */
export const releaseNoteField = (item, summary, btID) => {
  const releaseNote = item.fields.customfield_10044?.content[0]?.content[0]?.text;

  const key = btID ? `(${item.key}, BTID: ${btID})` : `(${item.key})`;

  if (!releaseNote || releaseNote?.includes("STORY TYPE")) {
    // The ***** indicates that there's no release notes field.
    return `***** ${summary} ${key}`;
  }
  return `${releaseNote} ${key}`;
};

/**
 * @param {object} data - Data results from the Jira API call.
 * @returns {object} The formatted data.
 * @description This function formats the data from the API call.
 * It returns an object with the following properties:
 * - id
 * - IssueType
 * - IssueKey
 * - IssueSummary
 * - IssueStatus
 * - Component
 * - ReleaseNotes
 */
export const getFormattedIssuesData = (data) => {
  return data.map((item) => {
    const component = item.fields.components[0];
    const btID = item.fields.customfield_10058 === null ? null : item.fields.customfield_10058;
    const internalOnly = item.fields.customfield_10045 === null ? false : true;

    const { status, summary, issuetype } = item.fields;
    const { key, id } = item;

    return {
      id,
      IssueType: issuetype.name,
      IssueKey: btID ? `${key} (${btID})` : key,
      IssueSummary: summary,
      IssueStatus: status.name,
      Component: component?.name,
      ReleaseNotes: releaseNoteField(item, summary, btID),
      InternalOnly: internalOnly,
    };
  });
};

export default getFormattedIssuesData;
